import { Component } from 'react'
import moment from 'moment'
import { FaChevronLeft, FaChevronRight, FaChevronCircleRight, FaChevronCircleLeft, FaRegWindowClose } from 'react-icons/fa'
import { BsPersonBoundingBox } from 'react-icons/bs'
import PatientSmall from './PatientSmall'
import './calendar.css'

class Calendar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            all: false,
            displayAppt: false,
            provider: null,
            patient: null,
            date: null,
            start: null,
            end: null,
            visit: 'Select Visit Type',
            title: '',
            facility: 'Select Facility',
            visits: [
                { type: 'Office Visit', selected: false },
                { type: 'Follow Up', selected: false },
                { type: 'Urgent', selected: false },
                { type: 'Walk In', selected: false }
            ],
            displayPatients: false,
            appt: null
        }
    }

    handleMonthChanged(dir) {
        this.props.onMonthChanged(dir)
    }

    handleDaySelected(date) {
        this.props.onDayChanged(date)
    }

    handleDayOOB(dir, day) {
        this.handleDaySelected(day)
        this.handleMonthChanged(dir)
    }

    handleAllChanged(e) {
        this.setState({ [e.target.value]: e.target.checked })
        this.props.onSelAll(e.target.checked)
    }

    handlePvdrSelected(pidx) {
        this.props.onPvdrSel(pidx)
    }

    handleVisitChanged(event) {
        let visit
        const visits = this.state.visits.map(v => { 
            if(v.type === event.target.value && event.target.checked) visit = v.type
            return { type: v.type, selected: v.type === event.target.value && event.target.checked } 
        })
        console.log(visit)
        this.setState({ visits, visit })
    }

    handleApptSel(pvdr, t, idx) {
        console.log(t)
        let appts = pvdr.appt ? pvdr.appt.filter(a => moment(a.start).isSameOrBefore(moment(t)) && moment(a.end).isSameOrAfter(moment(t).add(30, 'minutes'))) : []
        //console.log(pvdr, t, idx, appts, idx>-1 ? appts[idx] : 'oops')
        this.setState({ provider: pvdr, date: t, patient: idx > -1 ? appts[idx].resource : null, displayAppt: true, appt: idx > -1 ? appts[idx] : null, start: idx > -1 ? moment(appts[idx].start).format('HH:mm') : moment(t).format('HH:mm'), end: idx > -1 ? moment(appts[idx].end).format('HH:mm') : moment(t).add(30, 'minutes').format('HH:mm'), title: idx > -1 ? appts[idx].title : '' })
        this.props.onDateChanged(t)
    }

    handleApptClose() {
        this.setState({ displayAppt: false, patient: null, provider: null, date: null, start: null, end: null, appt: null })
    }

    handleApptSave() {
        if (this.state.provider && this.state.patient && this.state.visits.filter(v => v.selected).length === 1 && this.state.title && this.state.start && this.state.end) {
            //console.log(this.state)
            this.props.onApptSave(!this.state.appt || false, this.state.provider, { ...this.state.appt || {}, start: `${moment(this.state.date).format('YYYY-MM-DD')} ${this.state.start}`, end: `${moment(this.state.date).format('YYYY-MM-DD')} ${this.state.end}`, title: this.state.title, visit: this.state.visit, resource: this.state.patient })
            this.handleApptClose()
        }
    }

    handleOpenAppt() {
        console.log(this.state.date)
        if(this.state.provider && this.state.patient) this.props.onApptOpen(this.state.provider, this.state.patient)
    }

    isAppt(pvdr, t) {
        let appts = pvdr.appt ? pvdr.appt.filter(a => moment(a.start).isSameOrBefore(moment(t)) && moment(a.end).isSameOrAfter(moment(t).add(30, 'minutes'))) : []
        return appts.length > 0
    }

    handleChange = event => {
        this.setState({ [event.target.id]: event.target.value.replace(/[<>//]/g, ""), topMenu: null })
    }

    handlePatientClick() {
        this.setState({ displayPatients: true, patient: null })
    }

    handlePatientSelect(pidx) {
        this.setState({ patient: this.props.patients[pidx], displayPatients: false })
    }

    getPatients() {
        return this.props.patients.length > 0 ? <div className='Appt-Form-Row Cal-Flex-Wrap'>
            {
                this.props.patients.map((m, midx) => {
                    return <div className={`Appt-Patient`} key={`member-${midx}`} onClick={() => this.handlePatientSelect(midx)}>
                        <PatientSmall resource={m} />
                    </div>
                })
            }
        </div> : null
    }

    getAppt() {
        return <div className='Appt-Form-Container'>
            <div className='Appt-Form-Header'>
                <div>{`${this.state.provider.first} ${this.state.provider.last}`}</div>
                <div>{moment(this.state.date).format('lll')}</div>
                <div className='Appt-Form-Close' onClick={() => this.handleApptClose()}><FaRegWindowClose /></div>
            </div>
            <div className='Appt-Form-Row Appt-Form-Selection'>
                {this.state.visits.map((v, vidx) => {
                    return <div key={`visit-${vidx}`} className='Appt-Form-CB'>
                        <input value={v.type} type="checkbox" checked={v.selected} onChange={(event) => this.handleVisitChanged(event)} />
                        <span className='Appt-Form-CB-Text'>{v.type}</span>
                    </div>
                })}
            </div>
            <div className='Appt-Form-Row Appt-Form-Selection'>
                <div className='Appt-Form-CB'>
                    <div className='DS-TB-Label'>Visit Title</div>
                    <input id='title' className='Appt-Textbox' type='text' placeholder='Visit Title' value={this.state.title} onChange={this.handleChange} />
                </div>
            </div>
            <div className='Appt-Form-Row Appt-Section-Header'>
                Patient
            </div>
            <div className='Appt-Form-Patient-Container'>
                {this.state.displayPatients ? this.getPatients() : <div className='Appt-Form-Patient' onClick={() => this.handlePatientClick()}>{this.state.patient ? <PatientSmall resource={this.state.patient} /> : <BsPersonBoundingBox />}</div>}
            </div>
            <div className='Appt-Form-Row Appt-Section-Header'>
                Appointment Time
            </div>
            <div className='Appt-Form-Patient-Container .Cal-Flex-Spread'>
                <div className='Appt-Form-CB'>
                    <div className='DS-TB-Label'>Start</div>
                    <input id='start' className='Appt-Textbox' style={{ width: '150px' }} type='time' value={this.state.start} onChange={this.handleChange} />
                </div>
                <div className='Appt-Form-CB'>
                    <div className='DS-TB-Label'>End</div>
                    <input id='end' className='Appt-Textbox' style={{ width: '150px' }} type='time' value={this.state.end} onChange={this.handleChange} />
                </div>
            </div>
            <div className='Appt-Form-Row Appt-Section-Header'>

            </div>
            <div className='Appt-Form-Row Appt-Form-Footer'>
                <div className={`Appt-Button ${this.state.visit && this.state.title && this.state.start && this.state.end ? 'Appt-Button-Save' : 'Appt-Button-Off'}`} onClick={() => this.handleApptSave()}>Save</div>
                <div className={`Appt-Button ${this.state.appt && this.state.appt.id ? 'Appt-Button-Open' : 'Appt-Button-Off'}`} onClick={() => this.handleOpenAppt()}>Open</div>
                <div className='Appt-Button Appt-Button-Cancel' onClick={() => this.handleApptClose()}>Cancel</div>
            </div>
        </div>
    }

    getAppts(pvdr, t) {
        let appts = pvdr.appt ? pvdr.appt.filter(a => moment(a.start).isSameOrBefore(moment(t)) && moment(a.end).isSameOrAfter(moment(t).add(30, 'minutes'))) : []
        let apptsText = []
        appts.forEach(a => {
            if (moment(a.start).isSameOrAfter(moment(t)) && moment(a.start).isSameOrBefore(moment(t).add(30, 'minutes'))) {
                apptsText.push(`${a.resource.name[0].given.toString().replace(/,/g, ' ')} ${a.resource.name[0].family} (${a.resource.identifier[0].value}): ${a.title}`)
            }
        })
        return apptsText
    }

    getCal() {
        let month = moment(this.props.date)
        let one = moment(`${month.month() + 1}/1/${month.year()}`).day()
        let hasAppt = []
        let days = []
        let dates = []
        for (let i = 0; i < one; i++) {
            let tmp = moment(`${month.month() + 1}/1/${month.year()}`)
            tmp.subtract(one - i, 'days')
            days.push(tmp.date())
        }
        let last = days.length
        let tmp = month.daysInMonth()
        for (let i = 1; i <= tmp; i++) {
            days.push(i)
            const d = moment(`${month.month() + 1}/${i}/${month.year()}`)
            dates.push(d.format('YYYY-MM-DD'))
        }
        let next = days.length
        let rem = 42 - days.length
        for (let i = 1; i <= rem; i++) {
            days.push(i)
        }
        return <div className='Calendar-Container'>
            <div className='Calendar-Header'>
                <div className='Calendar-Buttons-Container'>
                    <div onClick={() => this.handleMonthChanged('back')} style={{ cursor: 'pointer', margin: '0px 5px' }}><FaChevronLeft /></div>
                    <div className='Calendar-Header-Text'>{moment(this.props.date).format('MMMM YYYY')}</div>
                    <div onClick={() => this.handleMonthChanged('next')} style={{ cursor: 'pointer', margin: '0px 5px' }}><FaChevronRight /></div>
                </div>
            </div>
            <div className='Calendar-Days-Header'>
                {['Su', 'Mn', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d, didx) => {
                    return <div key={`wd-${didx}`} className='Calendar-WD'>{d}</div>
                })}
            </div>
            <div className='Calendar-Days-Container'>
                {
                    days.filter((day, dayidx) => dayidx < last).map((day, didx) => {
                        return <div key={`day-${didx}`} className={`Calendar-Day Calendar-Day-Off${didx === 0 ? ' Calendar-Topleft' : ''}${didx === 6 ? ' Calendar-Topright' : ''}`} onClick={() => this.handleDayOOB('back', day)}>
                            {day}
                        </div>
                    })
                }
                {
                    days.filter((d, dayidx) => dayidx >= last && dayidx < next).map((day, didx) => {
                        return <div key={`day-${didx}`} className={`Calendar-Day${(didx + last) === 0 ? ' Calendar-Topleft' : ''}${(didx + last) === 6 ? ' Calendar-Topright' : ''}${(didx + last) === 35 ? ' Calendar-Bottomleft' : ''}${(didx + last) === 41 ? ' Calendar-Bottomright' : ''}${hasAppt.indexOf(day) > -1 ? ' Calendar-Day-Event' : ''}${moment(this.props.date).date() === day ? ' Calendar-Day-Sel' : ''}`} onClick={() => this.handleDaySelected(dates[didx])}>
                            {day}
                        </div>
                    })
                }
                {
                    days.filter((day, dayidx) => dayidx >= next).map((day, didx) => {
                        return <div key={`day-${didx}`} className={`Calendar-Day Calendar-Day-Off${(didx + next) === 35 ? ' Calendar-Bottomleft' : ''}${(didx + next) === 41 ? ' Calendar-Bottomright' : ''}`} onClick={() => this.handleDayOOB('next', day)}>
                            {day}
                        </div>
                    })
                }
            </div>
        </div>
    }

    getProviders() {
        return this.props.providers ? <div className='Cal-Providers-Container'>
            <div className='Cal-Providers-Header'>
                <div className='Cal-Providers-CB'>
                    <input value="all" type="checkbox" checked={this.state.all} onChange={(event) => this.handleAllChanged(event)} />
                </div>
                <div className='Cal-Providers-Text'>
                    Last
                </div>
                <div className='Cal-Providers-Text'>
                    First
                </div>
                <div className='Cal-Providers-Text'>
                    Specialty
                </div>
            </div>
            {
                this.props.providers.map((pvdr, pidx) => {
                    return <div key={`pvdr-${pidx}`} className={`Cal-Providers-Row${pvdr.selected ? ' Cal-Providers-Row-Sel' : (pidx % 2 ? '' : ' Cal-Providers-Row-Alt')}`}>
                        <div className='Cal-Providers-CB'>
                            <input type="checkbox" checked={pvdr.selected} onChange={(event) => this.handlePvdrSelected(pidx)} />
                        </div>
                        <div className='Cal-Providers-Text'>
                            {pvdr.last}
                        </div>
                        <div className='Cal-Providers-Text'>
                            {pvdr.first}
                        </div>
                        <div className='Cal-Providers-Text'>
                            {pvdr.specialty}
                        </div>
                    </div>
                })
            }
        </div> : null
    }

    getSchedules() {
        let t = moment(`${moment(this.props.date).format('l')} 06:00`)
        const times = []
        for (let i = 0; i < 12; i++) {
            times.push(t.format())
            t.add(30, 'minutes')
            times.push(t.format())
            t.add(30, 'minutes')
        }
        return this.props.providers && this.props.providers.filter(p => p.selected).length > 0 ? <div className='Cal-Col' style={{ width: 'calc(100% - 365px)' }}>
            <div className='Sched-Date'>
                <div className='Sched-Buttons-Container'>
                    <div onClick={() => this.handleDaySelected(moment(this.props.date).subtract(1, 'day'))} style={{ cursor: 'pointer', margin: '0px 5px' }}><FaChevronCircleLeft /></div>
                    <div className='Calendar-Header-Text'>{moment(this.props.date).format('LL')}</div>
                    <div onClick={() => this.handleDaySelected(moment(this.props.date).add(1, 'day'))} style={{ cursor: 'pointer', margin: '0px 5px' }}><FaChevronCircleRight /></div>
                </div>
            </div>
            <div className='Sched-Container'>
                <div className='Cal-Col'>
                    <div className='Sched-Pvdr'></div>
                    <div className='Sched-Time-Col'>
                        {
                            times.map((t, tidx) => {
                                return <div key={`time-${tidx}`} className={`Sched-Time-Block-${tidx % 2}`}>{moment(t).format('h:mm A')}</div>
                            })
                        }
                    </div>
                </div>
                {
                    this.props.providers.filter(p => p.selected).map((pvdr, pidx) => {
                        return <div key={`sched-${pidx}`} className='Cal-Col' style={{ width: `${100 / this.props.providers.filter(p => p.selected).length - 1}%` }}>
                            <div className='Sched-Pvdr'>{`${pvdr.first} ${pvdr.last}`}</div>
                            {
                                times.map((t, tidx) => {
                                    return <div key={`time-${tidx}`} className={`Sched-Time-Block-${tidx % 2}${this.isAppt(pvdr, t) ? ' Sched-Appt-Booked' : ' Sched-Appt'}`} onClick={() => !this.isAppt(pvdr, t) && this.handleApptSel(pvdr, t, -1)}>
                                        <div className='Sched-Appts'>
                                            {
                                                this.getAppts(pvdr, t).map((appt, apptidx) => {
                                                    return <div key={`appt-${pidx}-${tidx}-${apptidx}`} className='' onClick={() => this.handleApptSel(pvdr, t, apptidx)}>{appt}</div>
                                                })
                                            }
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    })
                }
            </div>
        </div> : null
    }

    render() {
        //console.log(this.props, this.state)
        return <div className='Cal-Container'>
            <div className='Cal-Col' style={{ width: '345px' }}>
                {this.getCal()}
                {this.getProviders()}
                <div className='Cal-Clinic'>Signature Florida Medical Clinic</div>
            </div>
            {this.getSchedules()}
            {this.state.displayAppt && this.getAppt()}
        </div>
    }
}

export default Calendar